import { render, staticRenderFns } from "./firstEnter.vue?vue&type=template&id=2dd4a20f&scoped=true&"
import script from "./firstEnter.vue?vue&type=script&lang=js&"
export * from "./firstEnter.vue?vue&type=script&lang=js&"
import style0 from "./firstEnter.vue?vue&type=style&index=0&id=2dd4a20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4a20f",
  null
  
)

export default component.exports